var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "48", height: "48", viewBox: "0 0 48 48", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement(
      "g",
      { clipPath: "url(#svg1107831571a)" },
      React.createElement("path", { d: "M24 48c13.255 0 24-10.745 24-24S37.255 0 24 0 0 10.745 0 24s10.745 24 24 24z", fill: "#F0F0F0" }),
      React.createElement("path", { d: "M47.86 26.609l-.001-.001zM47.858 26.609v-.001L21.538.125c-1.187.12-2.349.328-3.478.616C7.678 3.384 0 24 0 24s33.6 22.484 37.433 19.89a24.084 24.084 0 0 0 2.202-1.683L24.037 26.61h23.821z", fill: "#0052B4" }),
      React.createElement("path", { d: "M41.74 24L18.397.659C7.846 3.182 0 12.674 0 24c0 13.255 10.745 24 24 24 5.028 0 9.694-1.547 13.55-4.19L17.74 24h24z", fill: "#D80027" }),
      React.createElement("path", { d: "M22.826 35.437l-2.932-1.379 1.561-2.838-3.182.608-.404-3.215-2.217 2.365-2.217-2.365-.403 3.215-3.183-.609 1.561 2.84-2.931 1.378 2.931 1.378-1.56 2.84 3.182-.61.403 3.216 2.217-2.365 2.217 2.365.404-3.216 3.182.61-1.56-2.84 2.93-1.378zM20.87 13.31l-2.132-1.002 1.135-2.064-2.315.443-.293-2.34-1.613 1.72-1.612-1.72-.294 2.34-2.315-.443 1.136 2.064-2.132 1.003 5.217 1.043 5.218-1.043zM21.913 13.31a6.26 6.26 0 1 1-12.522 0", fill: "#F0F0F0" })
    ),
    React.createElement(
      "defs",
      null,
      React.createElement(
        "clipPath",
        { id: "svg1107831571a" },
        React.createElement("path", { fill: "#fff", d: "M0 0h48v48H0z" })
      )
    )
  );
});